// 
document.addEventListener("DOMContentLoaded", function () { 
    $('.js-qual-register').on('click', function () {
        const selectedCountry = $(this).data("country");
        const selectedCity = $(this).data("city");
        const selectedClub = $(this).data("club");
        const $countrySelect = $('.register__form').find('.country-select');
        const $citySelect = $('.register__form').find('.city-select');
        const $clubSelect = $('.register__form').find('.club-select');

        $countrySelect.val(selectedCountry).trigger("change");
        $citySelect.val(selectedCity).trigger("change");
        $clubSelect.val(selectedClub).trigger("change");
    })
})